/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function choosePhoneContact(options, context) {
    var _a;
    var api = 'dd.biz.contact.chooseMobileContacts';
    var formatOutput = function (ret) {
        var selectItem = ret[0];
        return {
            name: selectItem.name,
            phone: selectItem.mobile.replace(/(\s|-)+/g, ''),
            multiple: false,
        };
    };
    (_a = context === null || context === void 0 ? void 0 : context.DDCall) === null || _a === void 0 ? void 0 : _a.call(context, api, options, { formatOutput: formatOutput });
}

export { choosePhoneContact as default };
